function updateAddToCartOnChange(element) {
  let buttons = element.querySelectorAll(".rc-template__button-group .rc-radio");
  const addToCart = document.querySelector(".product-form__submit span");
  const addToCartPrice = addToCart.querySelector('.js-product-price');
  let mainPrice = document.querySelector(".js-price [data-price]");
  let buttonPrices = document.querySelectorAll('.js-product-price');
  const rechargePopup = document.querySelector('.recharge-modal-opener');

  rechargePopup.classList.add('recharge-present');

  document.addEventListener("priceUpdateEvent", function() {
    buttons = document.querySelectorAll(".rc-template__button-group .rc-radio");
    if (buttons) {
      buttons.forEach(button => {
        if (button.classList.contains('rc-radio--active')) {
          const isSubscription = hasClass(button, "subscription-radio") || hasClass(button, "rc_widget__option--subsave");
          const rechargeCurrentPrice = button.querySelector(".rc-radio__label .price-label");
          const fullPrice = document.querySelector('.onetime-radio .price-label')
          mainPrice = document.querySelector(".js-price [data-price]");
          buttonPrices = document.querySelectorAll('.js-product-price');
      
          if (isSubscription) {
            const currentPrice = rechargeCurrentPrice.innerHTML;
            mainPrice.innerHTML = currentPrice;
            buttonPrices.forEach(buttonPrice => {
              buttonPrice.innerHTML = currentPrice;
            })
          } else {
            mainPrice.innerHTML = fullPrice.innerHTML;
            buttonPrices.forEach(buttonPrice => {
              buttonPrice.innerHTML = fullPrice.innerHTML;
            })
          }
        }

        button.addEventListener("click", () => {
          const rechargePrice = button.querySelector(".rc-radio__label .price-label").innerHTML;
          
          mainPrice = document.querySelector(".js-price [data-price]");
          buttonPrices = document.querySelectorAll('.js-product-price');
  
          if (addToCartPrice) {
            addToCartPrice.innerHTML = rechargePrice;
          }
          mainPrice.innerHTML = rechargePrice;
          buttonPrices.forEach(buttonPrice => {
            buttonPrice.innerHTML = rechargePrice;
          })
        });
      })
    }
  })
  
  if (buttons) {
    buttons.forEach(button => {
      const rechargePrice = button.querySelector(".rc-radio__label .price-label").innerHTML;
      const isSubscription = hasClass(button, "subscription-radio") || hasClass(button, "rc_widget__option--subsave");

      if (isSubscription) {
        mainPrice.innerHTML = rechargePrice;
        buttonPrices.forEach(buttonPrice => {
          buttonPrice.innerHTML = rechargePrice;
        })
      } 

      button.addEventListener("click", () => {
        mainPrice = document.querySelector(".js-price [data-price]");
        buttonPrices = document.querySelectorAll('.js-product-price');

        if (addToCartPrice) {
          addToCartPrice.innerHTML = rechargePrice;
        }
        mainPrice.innerHTML = rechargePrice;
        buttonPrices.forEach(buttonPrice => {
          buttonPrice.innerHTML = rechargePrice;
        })
      });
    });  
  }  

  const rechargeSel = document.querySelector('.rc-selling-plans__dropdown');
  const rechargeOptions = document.querySelectorAll('.rc-selling-plans__dropdown option');
  const rechargeOptionContainer = document.querySelector('.rc_widget__option__plans__dropdown');
  const rechargeDataOptionContainer = document.createElement('div');

  rechargeDataOptionContainer.classList.add('rc-data-option-container');

  rechargeOptions.forEach((option, i) => {
    // Create Recharge option buttons, add Recharge data and classes to new elements.
    let element = document.createElement('span');
    let optionData = option.getAttribute('data-plan-option');
    let valueData = option.getAttribute('value');

    element.classList.add('rc-data-option');
    element.setAttribute('data-plan-option', optionData);
    element.setAttribute('value', valueData);
    element.innerHTML = option.innerHTML;

    rechargeOptionContainer.parentElement.appendChild(rechargeDataOptionContainer);
    rechargeDataOptionContainer.appendChild(element);

    let rechargeOptionBtns = document.querySelectorAll('.rc-button-group__options');

    rechargeOptionBtns[0].classList.add('rc-data-option--selected');

    const rechargeBtnClick = function rechargeBtnClick(selector) {
      // Add element event listeners and update selected frequency text.
      selector.forEach((btn, i) => {
        btn.addEventListener('click', () => {
          rechargeOptionBtns.forEach(el => el.classList.remove('rc-data-option--selected'));

          if (btn.classList.contains('rc-data-option--selected')) {
            btn.classList.remove('rc-data-option--selected')
          } else {
            btn.classList.add('rc-data-option--selected');
            rechargeSel.options[i].selected = true;
            rechargeSel.dispatchEvent(new Event('change'));
          }

          let selectedPlanLabelEl = document.createElement('span');

          selectedPlanLabelEl.innerHTML = 'FREQUENCY |' + '<span class="freq-option">' + btn.getAttribute('data-plan-option') + '</span>'; 
        });
      });
    }

    rechargeBtnClick(rechargeOptionBtns);
  });

}

const hasClass = (element, name) => element.classList.contains(name);

// Create MutationObserver to wait for recharge widget to load
const waitForElm = function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) return resolve(document.querySelector(selector));

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));

        observer.disconnect();
      }
    });

    observer.observe(document.body, {childList: true, subtree: true});
  });
}

// Check when the recharge widget loads
waitForElm('.rc-widget').then(element => updateAddToCartOnChange(element));